import { render, staticRenderFns } from "./SupplierRefundFlow.vue?vue&type=template&id=3475ac08&scoped=true&"
import script from "./SupplierRefundFlow.vue?vue&type=script&lang=js&"
export * from "./SupplierRefundFlow.vue?vue&type=script&lang=js&"
import style0 from "./SupplierRefundFlow.vue?vue&type=style&index=0&id=3475ac08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3475ac08",
  null
  
)

export default component.exports